// extracted by css-extract-rspack-plugin
export default {"root":"EntityPickerTab_root__rKoun","active":"EntityPickerTab_active__OIy-G","error":"EntityPickerTab_error__14GzP","badge":"EntityPickerTab_badge__Ikco+"};